import {createAction} from 'redux-actions'

const action = name => createAction(`company-report/${name}`)

export const setCounts = action('SET_COUNTS')
export const setStoryIdsByFactor = action('SET_STORY_IDS_BY_FACTOR')
export const setIsLoading = action('SET_IS_LOADING')
export const startDownloadPdf = action('START_DOWNLOAD_PDF')
export const finishDownloadPdf = action('FINISH_DOWNLOAD_PDF')
